import { gql, useQuery } from '@apollo/client'
import { useMemo, useState } from 'react'

interface IQueryDataType {
  listItems: {
    nodes: {
      itemCode: string
      itemType: string
      itemDisplayName: string
      displayParentCategoryId: number
      displayParentCategoryName: string
    }[]
  }
}

export interface IDataType {
  fwWingstopProductMixItems: {
    fwWingstopProductMixItems: string[]
    itemKeywords: string
    setItemKeywords: (keyword: string) => void
  }
}

const query = gql`
  query ($iRoot: String!) {
    listItems(iRoot: $iRoot) {
      nodes {
        itemCode
        itemType
        itemDisplayName
        displayParentCategoryId
        displayParentCategoryName
      }
    }
  }
`

const useFwWingstopProductMixItems = (): IDataType => {
  const { data } = useQuery<IQueryDataType>(query, {
    variables: {
      iRoot: 'EXPO_MENU_CATEGORY_ROOT',
    },
  })

  const [itemKeywords, setItemKeywords] = useState('')

  const fwWingstopProductMixItems = useMemo(() => {
    return (
      data?.listItems?.nodes
        ?.filter(
          ({ itemType, displayParentCategoryId, itemCode }) =>
            itemType === 'ITEM' &&
            displayParentCategoryId === 1 &&
            (!itemKeywords ||
              itemCode.toLowerCase().includes(itemKeywords.toLowerCase())),
        )
        .map(({ itemCode }) => itemCode) ?? []
    )
  }, [data, itemKeywords])

  return {
    fwWingstopProductMixItems: {
      fwWingstopProductMixItems,
      itemKeywords,
      setItemKeywords,
    },
  }
}

export default useFwWingstopProductMixItems
